import {registerCommonPopup} from '@/commons/popupRegister/commonPopupRegister.js';

export function register(app) {
  registerCommonPopup(app);
}
